import {TableContainer, TableBody, TableCell, TableHead, TableRow, Paper, Table} from '@mui/material';
import {useTranslation} from "react-i18next";
import StatsRow from './StatsRow.js';

const StatsMonthTable = (props) => {
	const {t} = useTranslation('obs');
	const src = props.src;

	function monthSrc() {
		let prev_y = -1, i;
		let ret = [];

		let ol = src.length;

		for (i = ol - 1; i >= 0 ; i--) {
			let obs = src[i], bg;
			const y = new Date(obs.start_t * 1000.0).getYear();

			if (y !== prev_y) {
				let j, n;

				n = 1;

				for (j = i - 1; j >= 0; j--) {
					let obs2 = src[j];
					const y2 = new Date(obs2.start_t * 1000.0).getYear();

					if (y2 !== y) 
						break;

					n++;
				}

				if (prev_y !== -1)
					ret.push(<TableRow key={-y * 2 - 1}><TableCell colSpan={4}>&nbsp;</TableCell></TableRow>);

				ret.push(<TableRow key={-y * 2} style={{backgroundColor: '#f0f0f0'}}><TableCell colSpan={4}>{(y + 1900) + ' ' + n + ' ' + t('stats.species')}</TableCell></TableRow>);
			}

			bg =  src[i].lifer ? '#cbffe2' : '#ffffff';

			ret.push(
				<StatsRow
					key	= {i + 1}
					bgcolor	= {bg}
					row_n	= {i + 1}
					obs	= {obs}
				/>);

			prev_y = y;
		}

		return ret;
	}

	if (!props.src || !Array.isArray(props.src))
		return null;

	return (
		<TableContainer component={Paper} elevation={0}>
			<Table size='small'>
				{!props.hideHeader &&
					<TableHead>
						<TableRow>
							<TableCell>#</TableCell>
							<TableCell>{t('main.species')}</TableCell>
							<TableCell>{t('main.time')}</TableCell>
							<TableCell>{t('main.location')}</TableCell>
						</TableRow>
					</TableHead>
				}
				<TableBody>
					{monthSrc()}
				</TableBody>
			</Table>
		</TableContainer>
	);
}

export default StatsMonthTable;
